module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#arrow",
      toString: function () {
        return this.url;
      }
    }